module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form"
  }, [_c('el-dialog', {
    attrs: {
      "title": _vm.title,
      "visible": _vm.DialogVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.DialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单类别:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.OrderSourceName))])])], 1), _vm._v(" "), _c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.OrderSource == 4),
      expression: "form.OrderSource==4"
    }],
    attrs: {
      "span": 5
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "团购人数:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.groupNum))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 13
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单号:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.OrderCode))])])], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.OrderSource == 4),
      expression: "form.OrderSource==4"
    }],
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "其余团购订单:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.OtherOrder))])])], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.OrderSource == 3),
      expression: "form.OrderSource==3"
    }]
  }, [_c('h4', [_vm._v("转介绍人信息")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "转介绍宝贝ID:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.RefereeBabyInfo.Id))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "转介绍宝贝姓名:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.RefereeBabyInfo.BabyName))])])], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.RefereeBabyAgentInfo.AgentName !== undefined) ? _c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属代理商:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.RefereeBabyAgentInfo.AgentName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属园所:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.RefereeBabySchoolInfo.SchoolName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属班级:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.RefereeBabyClassInfo.ClassName))])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "转介绍家长:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.RefereeParentInfo.UserName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "转介绍家长电话:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.RefereeParentInfo.PhoneNo))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "与宝贝家庭关系:",
      "label-width": "130px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.RefereeParentInfo.ParentNick))])])], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('h4', [_vm._v("下单人信息")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学员ID:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.BabyId))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学员姓名:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.BabyInfo.BabyName))])])], 1)], 1), _vm._v(" "), _c('el-row', [(_vm.form.AgentInfo !== undefined) ? _c('div', [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属代理商:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.AgentInfo.AgentName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属园所:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.SchoolInfo.SchoolName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "所属班级:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ClassInfo.ClassName))])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "下单家长:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.UserName))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "下单家长电话:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.UserTel))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 7
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "与宝贝家庭关系:",
      "label-width": "130px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.ParentNick))])])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "下单时间:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.OrderTime))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "订单状态:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.OrderStatusName))])]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.form.AuditRemark !== ''),
      expression: "form.AuditRemark!==''"
    }],
    attrs: {
      "label": "审核备注:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.AuditRemark))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "发货状态:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.SendStatusName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属套餐:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.PackageName))])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "套餐价:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.PayMoney) + "元")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAudit),
      expression: "!isAudit"
    }]
  }, [_c('h4', [_vm._v("套餐配套实物详情:")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10px"
    },
    attrs: {
      "data": _vm.form.ProductList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "ProductName",
      "label": "商品名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "ProNum",
      "label": "商品数量"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "StockOutNum",
      "label": "已发货数量"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAudit),
      expression: "!isAudit"
    }]
  }, [_c('h4', [_vm._v("套餐配套课程详情:")]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "80%",
      "margin-left": "10px"
    },
    attrs: {
      "data": _vm.form.CourseList,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "CourseName",
      "label": "课程类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CourseNum",
      "label": "课时数"
    }
  })], 1)], 1), _vm._v(" "), _c('div', [_c('h4', [_vm._v("支付详情:")]), _vm._v(" "), _vm._l((_vm.form.OrderPayInfo), function(item, index) {
    return _c('el-row', [_c('el-form-item', {
      attrs: {
        "label": '支付方式-' + (index + 1)
      }
    }, [_c('span', [_vm._v(_vm._s(item.PayTypeName))])]), _vm._v(" "), (item.PayWay !== 6 && item.PayWay !== 9) ? _c('el-form-item', {
      attrs: {
        "label": "支付金额"
      }
    }, [_c('span', [_vm._v(_vm._s(item.OrderActualPrice))])]) : _vm._e(), _vm._v(" "), (item.PayWay == 5) ? _c('el-form-item', {
      attrs: {
        "label": "支付凭证"
      }
    }, _vm._l((item.VoucherPic), function(item2) {
      return _c('div', {
        attrs: {
          "id": "ImgPrev"
        }
      }, [_c('div', {
        staticClass: "post-format-content"
      }, [_c('div', {
        staticClass: "post-thumbnail"
      }, [_c('img', {
        staticClass: "attachment-thumbnail wp-post-image",
        attrs: {
          "id": "myProPic",
          "src": item2.Url
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "content-wrap"
      }, [_c('span', {
        staticClass: "entry-title"
      }, [_c('span', {
        staticClass: "featured-image",
        on: {
          "click": function($event) {
            _vm.LookPicture(item2.Url)
          }
        }
      }, [_c('i', {
        staticClass: "el-icon-view"
      })])])])])])
    })) : _vm._e(), _vm._v(" "), (item.Trade_No != '') ? _c('el-form-item', {
      attrs: {
        "label": "支付凭证单号"
      }
    }, [_c('span', [_vm._v(_vm._s(item.Trade_No))])]) : _vm._e(), _vm._v(" "), (item.PayWay == 8) ? _c('el-form-item', {
      attrs: {
        "label": "支付说明"
      }
    }, [_c('span', [_vm._v(_vm._s(item.PayRemark))])]) : _vm._e()], 1)
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAudit && _vm.form.OrderStatus !== 1),
      expression: "!isAudit && form.OrderStatus!==1"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "打款方式"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.AuditShowData.PayWayModeName) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AuditShowData.Payer !== ''),
      expression: "AuditShowData.Payer!==''"
    }],
    attrs: {
      "label": "打款人"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.AuditShowData.Payer) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "凭证金额"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.AuditShowData.VoucherMoney) + "\n        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "凭证单号"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.AuditShowData.PreReceiveCode) + "\n        ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isAudit),
      expression: "!isAudit"
    }]
  }, [_c('h4', [_vm._v("收货地址:")]), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货人:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeList.Consignee))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "收货电话:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeList.ConsigneeTel))])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "详细地址:"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.ConsigneeList.ConsigneeProvName) + _vm._s(_vm.ConsigneeList.ConsigneeCityName) + _vm._s(_vm.ConsigneeList.ConsigneeAreaName) + _vm._s(_vm.ConsigneeList.ConsigneeAddress))])])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isReadOnly),
      expression: "!isReadOnly"
    }],
    attrs: {
      "label": "配置资源包:"
    }
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "margin-left": "0px",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.packages,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "资源包"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v("\n              " + _vm._s(scope.row.ProName) + "\n            ")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "数量"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input-number', {
          staticStyle: {
            "margin-left": "5px"
          },
          attrs: {
            "size": "small",
            "min": 0
          },
          model: {
            value: (scope.row.ProNum),
            callback: function($$v) {
              _vm.$set(scope.row, "ProNum", $$v)
            },
            expression: "scope.row.ProNum"
          }
        })]
      }
    }])
  })], 1)], 1), _vm._v(" "), (_vm.isAudit) ? _c('div', {
    staticStyle: {
      "border-top": "1px solid #ddd",
      "heght": "1px",
      "width": "100%",
      "margin-bottom": "20px"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isAudit) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "审核意见",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.AuditData.OrderStatus),
      callback: function($$v) {
        _vm.$set(_vm.AuditData, "OrderStatus", $$v)
      },
      expression: "AuditData.OrderStatus"
    }
  }, _vm._l((_vm.status), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AuditData.OrderStatus == 6),
      expression: "AuditData.OrderStatus==6"
    }]
  }, [_c('el-form-item', {
    attrs: {
      "label": "打款方式",
      "label-width": "100px"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.AuditData.PayWayMode),
      callback: function($$v) {
        _vm.$set(_vm.AuditData, "PayWayMode", $$v)
      },
      expression: "AuditData.PayWayMode"
    }
  }, _vm._l((_vm.PayWayModes), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.AuditData.PayWayMode == 1),
      expression: "AuditData.PayWayMode==1"
    }],
    attrs: {
      "label": "打款人",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    staticClass: "formlength",
    model: {
      value: (_vm.AuditData.Payer),
      callback: function($$v) {
        _vm.$set(_vm.AuditData, "Payer", $$v)
      },
      expression: "AuditData.Payer"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "凭证金额",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    staticClass: "formlength",
    model: {
      value: (_vm.AuditData.VoucherMoney),
      callback: function($$v) {
        _vm.$set(_vm.AuditData, "VoucherMoney", $$v)
      },
      expression: "AuditData.VoucherMoney"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "预收单",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    model: {
      value: (_vm.AuditData.PreReceiveCode),
      callback: function($$v) {
        _vm.$set(_vm.AuditData, "PreReceiveCode", $$v)
      },
      expression: "AuditData.PreReceiveCode"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "审核备注",
      "label-width": "100px"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.AuditData.AuditRemark),
      callback: function($$v) {
        _vm.$set(_vm.AuditData, "AuditRemark", $$v)
      },
      expression: "AuditData.AuditRemark"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    on: {
      "click": _vm.dialogClose
    }
  }, [_vm._v("关闭")]), _vm._v(" "), (!_vm.isReadOnly) ? _c('el-button', {
    attrs: {
      "type": "success",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确认")]) : _vm._e(), _vm._v(" "), (_vm.isAudit) ? _c('el-button', {
    attrs: {
      "type": "success",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.AuditSubmit
    }
  }, [_vm._v("确认")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-586bc21e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Family/OrderList/viewDialog/index.vue
// module id = 1487
// module chunks = 1